import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import dynamic from 'next/dynamic';

const ClientOnlyHTML = dynamic(
  () =>
    Promise.resolve(
      ({ html, tag = 'p' }: { html: string; tag?: 'p' | 'div' }) => {
        const sanitizedHtml = html.replace(
          /<(?!\/?a(?:\s+(?:href|target|rel|class|style|id})=["'][^"']*["'])*\s*\/?>)[^>]+>/gi,
          '',
        );
        const Tag = tag;
        return <Tag dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
      },
    ),
  { ssr: false },
);

function CategoryTemplateHead(props: any) {
  const { Head } = props;
  return (
    <div
      className={ivclass(
        'iv-flex sm:iv-justify-center',
        'iv-py-30 iv-px-60 md:iv-px-25 sm:iv-px-35',
        'iv-border-b iv-border-t iv-border-grey-5',
      )}
    >
      <div className={ivclass('iv-px-5')}>
        <h1
          className={ivclass(
            'iv-m-heading-2xs iv-text-heading-2xs md:iv-m-heading-4xs md:iv-text-heading-4xs sm:iv-text-heading-4xs',
            'iv-font-extrabold iv-text-grey-95',
            'iv-mb-10 iv-text-left sm:iv-text-center',
          )}
        >
          {Head.Title}
          {Head.HighlightedTitle && (
            <span className={ivclass('iv-gradient-dee-blue-blue-turquoise')}>
              {' '}
              {Head.HighlightedTitle}
            </span>
          )}
        </h1>

        <div
          className={ivclass(
            'sm:iv-text-center iv-m-body-xl iv-text-body-xl iv-text-grey-60 sm:iv-text-body-l sm:iv-m-body-l',
            'iv-max-w-xl iv-font-medium md:iv-mt-5',
          )}
        >
          <ClientOnlyHTML html={Head.SubTitle} tag="p" />
        </div>
      </div>
    </div>
  );
}

export default CategoryTemplateHead;
